/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShiftiePlainDate } from './ShiftiePlainDate';
import {
    ShiftiePlainDateFromJSON,
    ShiftiePlainDateFromJSONTyped,
    ShiftiePlainDateToJSON,
    ShiftiePlainDateToJSONTyped,
} from './ShiftiePlainDate';

/**
 * 
 * @export
 * @interface UpdateAbsenceRequestData
 */
export interface UpdateAbsenceRequestData {
    /**
     * 
     * @type {number}
     * @memberof UpdateAbsenceRequestData
     */
    absenceCategoryId?: number;
    /**
     * 
     * @type {ShiftiePlainDate}
     * @memberof UpdateAbsenceRequestData
     */
    startedOn?: ShiftiePlainDate;
    /**
     * 
     * @type {ShiftiePlainDate}
     * @memberof UpdateAbsenceRequestData
     */
    endedOn?: ShiftiePlainDate | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAbsenceRequestData
     */
    startedMidday?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAbsenceRequestData
     */
    endedMidday?: boolean;
    /**
     * Whether the employee will be paid for this period of absence
     * @type {boolean}
     * @memberof UpdateAbsenceRequestData
     */
    paid?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateAbsenceRequestData
     */
    notes?: string;
}

/**
 * Check if a given object implements the UpdateAbsenceRequestData interface.
 */
export function instanceOfUpdateAbsenceRequestData(value: object): value is UpdateAbsenceRequestData {
    return true;
}

export function UpdateAbsenceRequestDataFromJSON(json: any): UpdateAbsenceRequestData {
    return UpdateAbsenceRequestDataFromJSONTyped(json, false);
}

export function UpdateAbsenceRequestDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateAbsenceRequestData {
    if (json == null) {
        return json;
    }
    return {
        
        'absenceCategoryId': json['absenceCategoryId'] == null ? undefined : json['absenceCategoryId'],
        'startedOn': json['startedOn'] == null ? undefined : ShiftiePlainDateFromJSON(json['startedOn']),
        'endedOn': json['endedOn'] == null ? undefined : ShiftiePlainDateFromJSON(json['endedOn']),
        'startedMidday': json['startedMidday'] == null ? undefined : json['startedMidday'],
        'endedMidday': json['endedMidday'] == null ? undefined : json['endedMidday'],
        'paid': json['paid'] == null ? undefined : json['paid'],
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

  export function UpdateAbsenceRequestDataToJSON(json: any): UpdateAbsenceRequestData {
      return UpdateAbsenceRequestDataToJSONTyped(json, false);
  }

  export function UpdateAbsenceRequestDataToJSONTyped(value?: UpdateAbsenceRequestData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'absenceCategoryId': value['absenceCategoryId'],
        'startedOn': ShiftiePlainDateToJSON(value['startedOn']),
        'endedOn': ShiftiePlainDateToJSON(value['endedOn']),
        'startedMidday': value['startedMidday'],
        'endedMidday': value['endedMidday'],
        'paid': value['paid'],
        'notes': value['notes'],
    };
}

